import React from 'react'
import "./tooltip.scss"

export const ToolTip = ({ children, text }) => {
    return (
      <div className="tooltip-wrapper mb-0">
        {children}
        <span className="tooltip-text">{text}</span>
      </div>
    );
  };